// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"o0-z"};